import React from 'react';
import { useController } from 'react-hook-form';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/Components/shadcn/dialog';
import EmailTemplateViewer from '@/Components/EmailTemplate/EmailTemplateViewer';
import { useCompanyContext } from '@/Context/CompanyContext';
import { useUserContext } from '@/Context/UserContext';
import { EmailTemplateType } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';
import { TemplateEditorForm } from './TemplateEditor/utils';
import { getEmailTemplateHtml } from '../../utils/getEmailTemplateHtml';

export interface PreviewEmailDialogProps {
    open: boolean;
    dialogTitle: string;
    bodyHtml: string;
    thankYouMessage: string;
    templateType: EmailTemplateType;
    onClose?: () => void;
}

function PreviewEmailDialog({
    dialogTitle,
    bodyHtml,
    thankYouMessage,
    templateType,
    open,
    onClose,
}: PreviewEmailDialogProps): React.JSX.Element {
    const { field: titleField } = useController<TemplateEditorForm>({ name: 'title' });
    const { field: regardsField } = useController<TemplateEditorForm>({ name: 'regards' });
    const { user } = useUserContext();
    const { currentCompanyProfile } = useCompanyContext();

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose?.()}>
            <DialogContent className="max-w-xl border-none shadow-none">
                <DialogHeader className="flex flex-row items-center justify-between">
                    <DialogTitle>{dialogTitle}</DialogTitle>
                </DialogHeader>
                <div className="border-border mt-4 rounded-xl border p-4">
                    <EmailTemplateViewer
                        className="max-h-126 border-0"
                        htmlTemplate={getEmailTemplateHtml(
                            titleField.value,
                            thankYouMessage,
                            bodyHtml,
                            regardsField.value,
                            UIStrings.ApplicantsNamePlaceholder,
                            `${user?.firstName} ${user?.lastName}`,
                            currentCompanyProfile.companyName,
                            undefined,
                            templateType !== EmailTemplateType.RejectTemplate,
                        )}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default PreviewEmailDialog;
